import React from "react";
import { Box, Flex } from "rebass";
import { Form, Field } from "formik";

import {
  fields,
  FormTypes,
} from "./formSettings";

import { Input } from "../components/Input";
import { SubmitButton } from "../components/SubmitButton";
import { SpinnerSVG } from "../../components/svg/SpinnerSVG";

export function FormComponent({ isSubmitting, isValid }: FormTypes) {
  return (
    <Form>
      <Box>
        {
          fields.map(({ name, placeholder, type }) => (
            <Field
              key={name}
              name={name}
              type={type}
              placeholder={placeholder}
              component={Input}
            />
          ))
        }
      </Box>

      <Box
        mt="20px"
        fontSize="14px"
      >
        <SubmitButton disabled={isSubmitting || !isValid}>
          <Flex justifyContent="center" alignItems="center">
            <span>sign in</span>

            {
              isSubmitting && (
                <>
                  &nbsp;

                  <SpinnerSVG fill="#fff" size={16} />
                </>
              )
            }
          </Flex>
        </SubmitButton>
      </Box>
    </Form>
  );
}
